import React from "react";
import { ArrowUpRight } from "lucide-react";
import { useLanguage } from "../i18n/LanguageContext";

const FamilyMealsComingSoon = () => {
  const { t } = useLanguage();
  const p = t.familyMeals.comingSoon;

  return (
    <div data-testid="page-family-meals-coming-soon">
      {/* HERO */}
      <section className="border-b border-[#242424] relative overflow-hidden">
        <div
          className="pointer-events-none absolute -top-32 -right-32 h-[480px] w-[480px] rounded-full bg-[#E8490F]/12 blur-3xl"
          aria-hidden
        />
        <div className="mise-container pt-24 md:pt-32 pb-20 md:pb-28 flex flex-col items-center text-center">
          <img
            src="/images/family-meals-logo.svg"
            alt="Mise: Family Meals"
            className="w-full max-w-[360px] md:max-w-[420px] h-auto"
            draggable={false}
          />

          <div className="mt-12">
            <h1 className="text-4xl md:text-5xl font-semibold text-white tracking-tight leading-[1.15]">
              Surplus food,
            </h1>
            <p className="mise-serif text-4xl md:text-5xl mise-accent leading-tight mt-1">
              redirected with dignity.
            </p>
          </div>

          <p className="mt-10 text-2xl md:text-3xl font-semibold text-white/90 tracking-tight">
            {p.heading}
          </p>
        </div>
      </section>

      {/* JOIN THE NETWORK CTA */}
      <section className="mise-section">
        <div className="mise-container flex justify-center">
          <div className="mise-card p-10 md:p-14 max-w-2xl w-full text-center">
            <h3 className="text-3xl md:text-4xl font-semibold text-white leading-tight">
              {p.joinHeading}
            </h3>
            <p className="mt-3 text-white/70 text-lg leading-relaxed">{p.joinSub}</p>
            <div className="mt-8 flex flex-col sm:flex-row flex-wrap gap-3 justify-center">
              <a
                href="https://misefamilymeals.ca/pilot?type=restaurant"
                target="_blank"
                rel="noopener noreferrer"
                className="mise-pill-primary"
                data-testid="fm-coming-soon-cta-supplier"
                data-track="fm-coming-soon-supplier"
              >
                {p.joinCtaSupplier}
                <ArrowUpRight size={16} />
              </a>
              <a
                href="https://misefamilymeals.ca/pilot?type=nonprofit"
                target="_blank"
                rel="noopener noreferrer"
                className="mise-pill-secondary"
                data-testid="fm-coming-soon-cta-distributor"
                data-track="fm-coming-soon-distributor"
              >
                {p.joinCtaDistributor}
                <ArrowUpRight size={16} />
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default FamilyMealsComingSoon;
